
import foFooter from '@/components/footer/footer.vue'
import foHeader from '@/components/header/header.vue'
import { ClientPageType } from '@/constants'
import { dateHelper } from '@/helpers/dateHelper'
import { collectMixin } from '@/mixins'
import { SnackBarType } from '@/store/types'
import { COLLECT_STATUSES } from '@meltingpoint/shared-statuses'
import mixins from 'vue-typed-mixins'

const defaultBody = {
  informations: '',
  showDriveName: false,
  showInterval: false,
  title: '',
}

export default mixins(collectMixin).extend({
  name: 'drive-success',
  components: {
    foHeader,
    foFooter,
  },
  data() {
    return {
      hasLoaded: false,
      body: defaultBody,
    }
  },
  computed: {
    getEndDate(): string {
      const status = this.collect!.collectStatus.find(
        localStatus => localStatus.status === COLLECT_STATUSES.PICK_UP_OK,
      )

      if (!status) {
        return ''
      }

      return dateHelper.formatToTimezone(
        dateHelper.getUtcDate(status.date!, 'UTC'),
        this.collect!.customer.timezone,
        'PPPP - p',
      )
    },
  },
  async mounted() {
    try {
      const {
        query: { language }
      } = this.$route

      const languageToUse = language?.toString() || ''

      await this.getCollect(this.$route.name!, languageToUse)

      if (
        !this.collect!.collectStatus.find(status => status.status === COLLECT_STATUSES.PICK_UP_OK)
      ) {
        this.$router.push({ name: ClientPageType.COLLECT.REPORT_PRESENCE_AT_DRIVE })
      }

      this.body = { ...defaultBody, ...this.clientPage!.config.body }
    } catch (e) {
      this.$store.dispatch('setSnackbar', {
        message: this.$t('messages.error'),
        type: SnackBarType.ERROR,
      })
    }

    this.hasLoaded = true
  },
  watch: {
    clientPage: {
      deep: true,
      handler(next) {
        this.body = { ...defaultBody, ...next.config.body }
      },
    },
  },
})
